import CIcon from "@coreui/icons-react";
import {
  CCard,
  CCardBody,
  CCol,
  CRow,
  CTable,
  CTableHead,
  CTableBody,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CButton,
  CAvatar,
} from "@coreui/react";
import React, { useEffect, useState } from "react";
import { cilPeople, cilPlus } from "@coreui/icons";
import CustomPagination from "src/components/CustomPagination";
import { useNavigate, useParams } from "react-router";
import {
  getTripById,
  removeBookingOrderFromTrip,
} from "src/services/trip.services";
import demoAvatar from "src/assets/images/avatars/avatar.png";
import moment from "moment";
import { getBookingOrderLogs } from "src/services/booking.services";
import MessageModal from "src/components/MessageModal/MessageModal";
import RemoveOrderModal from "./RemoveOrderModal";
import toast from "react-hot-toast";
import useTableSort from "src/__custom_hook/useTableSort";
import TableColumnSortIcon from "src/components/Sort/TableColumnSortIcon";

const TripOrdersTable = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { sortConfig, setSortConfig, handleClickColumnSort } = useTableSort();

  const [localUser, setLocalUser] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  const [isRemove, setIsRemove] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState([]);
  const [bookingOrderLogs, setBookingOrderLogs] = useState([]);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const [selectedModalTitle, setSelectedModalTitle] = useState(null);
  const [visibleMessageModal, setVisibleMessageModal] = useState(false);
  const [selectedOderToRemove, setSelectedOrderToRemove] = useState(null);
  const [orderRemovePriority, setOrderRemovePriority] = useState(null);

  const handlePageChange = (newPage) => {
    // console.log("newPage",newPage)
    setCurrentPage(newPage);
    // getBookingOrderItem(newPage);
  };

  const getOrdersByTripId = (id, urlParams = null) => {
    setIsLoading(true);
    getTripById(id, urlParams)
      .then(async (response) => {
        console.log("in then");
        console.log(response);
        let bookingOrders = response.data;
        if (bookingOrders.length > 0) {
          setData(bookingOrders);
        } else {
          navigate("/manage-trip");
        }
      })
      .catch((error) => {
        if (!error?.response?.data?.success) navigate("/manage-trip");
      })
      .finally(() => setIsLoading(false));
  };

  const handleHistoryDetails = async (e, itemId) => {
    e.stopPropagation();
    await getBookingOrderLogsById(itemId);
  };

  const getBookingOrderLogsById = async (id) => {
    // setIsLoading(true)
    getBookingOrderLogs(id)
      .then(async (response) => {
        // setIsLoading(false)
        setBookingOrderLogs(response.data);
        const historyObj = {
          type: "history",
          data: response.data.reverse(),
        };
        setSelectedModalTitle("Booking Order History");
        setSelectedMessage(historyObj);
        setVisibleMessageModal(true);
      })
      .catch((error) => {
        // setIsLoading(false)
        console.error(error);
      });
  };

  // const handleDriverDetails = (driver, vehicleId) => {
  const handleDriverDetails = (driver, tagId) => {
    // console.log(driver,tagId)
    const driverObj = {
      type: "driver",
      firstName: driver.firstName,
      lastName: driver.lastName,
      tagId: tagId,
      // vehicleId: vehicleId,
      avatar: driver.avatar,
    };
    setSelectedModalTitle("Driver Details");
    setSelectedMessage(driverObj);
    setVisibleMessageModal(true);
  };

  const handleDeliveredDetails = (
    deliverEmployeeCode,
    deliverSignature,
    deliverTo,
    deliverImage
  ) => {
    const deliverObj = {
      type: "deliver",
      deliverEmployeeCode,
      deliverSignature,
      deliverTo,
      deliverImage,
    };
    setSelectedModalTitle("Receiver's Details");
    setSelectedMessage(deliverObj);
    setVisibleMessageModal(true);
  };

  const handleRemoveRejectOrder = async (e, id) => {
    e.preventDefault();
    if (id) {
      if (!orderRemovePriority) {
        toast.error("Please select an order priority");
        return;
      }
      let body = {
        tripIsAccepted: false,
        priority: orderRemovePriority.value,
      };
      setIsRemove(true);
      removeBookingOrderFromTrip(id, body)
        .then(async (response) => {
          if (response.success) {
            let filtered = data.filter((item) => item._id !== id);
            setData((prev) => filtered);
            setIsRemove(false);
            if (filtered.length === 0) {
              navigate("/manage-trip");
            }
          }
        })
        .catch((error) => console.log(error?.response?.data?.message))
        .finally(() => {
          setSelectedOrderToRemove(null);
          setIsRemove(false);
        });
    }
  };

  useEffect(() => {
    if (id && sortConfig.length > 0) {
      const params = {
        sort: sortConfig
          .map((config) => `${config.key}:${config.direction}`)
          .join(","),
      };
      getOrdersByTripId(id, params);
    } else if (id) {
      getOrdersByTripId(id);
    } else {
      console.log(null);
    }
  }, [id, sortConfig]);

  useEffect(() => {
    if (data.length > 0) {
      setTotalPages(Math.ceil(data.length / 10));
    }
  }, [sortConfig]);

  return (
    <>
      <CCard className="mb-4">
        <CCardBody>
          <CRow>
            <CCol sm={5}>
              <h4 id="traffic" className="card-title mb-0">
                Trip Booking Orders
              </h4>
              {/* <div className="small text-medium-emphasis">January - July 2021</div> */}
            </CCol>
          </CRow>
          <br />
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell className="text-center">
                  Status
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Action
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  History
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  <CIcon icon={cilPeople} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("bookingOrderId")}
                  style={{ cursor: "pointer" }}
                >
                  Booking Order ID{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "bookingOrderId" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("transferOrderNo")}
                  style={{ cursor: "pointer" }}
                >
                  Transfer Order No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "transferOrderNo" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("sealBag")}
                  style={{ cursor: "pointer" }}
                >
                  Seal/Bag No.{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "sealBag" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("fromLocation")}
                  style={{ cursor: "pointer" }}
                >
                  From Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "fromLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("toLocation")}
                  style={{ cursor: "pointer" }}
                >
                  To Location{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "toLocation" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("type")}
                  style={{ cursor: "pointer" }}
                >
                  Type
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "type" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("unit")}
                  style={{ cursor: "pointer" }}
                >
                  Unit
                  <TableColumnSortIcon {...{ sortConfig, dataKey: "unit" }} />
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("tripRoute")}
                  style={{ cursor: "pointer" }}
                >
                  Route Name
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "tripRoute" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Priority
                </CTableHeaderCell>
                <CTableHeaderCell
                  className="text-center"
                  onClick={() => handleClickColumnSort("pickupDateTime")}
                  style={{ cursor: "pointer" }}
                >
                  Pick Up Date{" "}
                  <TableColumnSortIcon
                    {...{ sortConfig, dataKey: "pickupDateTime" }}
                  />
                </CTableHeaderCell>
                <CTableHeaderCell className="text-center">
                  Remarks
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {isLoading ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="16">Loading...</CTableDataCell>
                </CTableRow>
              ) : data.length == 0 ? (
                <CTableRow className="text-center">
                  <CTableDataCell colSpan="16">
                    No data available
                  </CTableDataCell>
                </CTableRow>
              ) : (
                data.map((item, index) => (
                  <CTableRow
                    v-for="item in tableItems"
                    key={index}
                    data-id={item._id}
                    data-status={item.status}
                    className={
                      item.priority == "emergency" ? "emergency-color" : ""
                    }
                  >
                    <CTableDataCell className="text-center">
                      {item.status == "driver" ? (
                        <CButton
                          color="purple"
                          className="text-capitalize"
                          size="sm"
                          onClick={() =>
                            handleDriverDetails(
                              item?.tripId?.tripAssignedTo,
                              // item?.tripId?.tripAssignedTo?.tripVehicleId
                              item?.tripId?.tripAssignedTo?.tripTagId
                            )
                          }
                        >
                          Accepted
                        </CButton>
                      ) : (
                        ""
                      )}
                      {item.status == "delivered" ? (
                        <CButton
                          color="success"
                          className="text-capitalize"
                          size="sm"
                          style={{ color: "white" }}
                          onClick={() =>
                            handleDeliveredDetails(
                              item?.deliverEmployeeCode,
                              item?.deliverSignature,
                              item?.deliverTo,
                              item?.deliverImage
                            )
                          }
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}

                      {item.status == "assigned" ? (
                        <CButton
                          color="gray"
                          className="text-capitalize"
                          size="sm"
                          onClick={() =>
                            handleDriverDetails(
                              item?.tripId?.tripAssignedTo,
                              // item?.tripId?.tripAssignedTo?.tripVehicleId
                              item?.tripId?.tripAssignedTo?.tripTagId
                            )
                          }
                        >
                          {item.status}
                        </CButton>
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.status !== "delivered" ? (
                        <CButton
                          color="danger"
                          className="text-capitalize text-white"
                          size="sm"
                          onClick={() => setSelectedOrderToRemove(item._id)}
                          disabled={
                            !["superAdmin", "admin", "cvit"].includes(
                              localUser.userType
                            ) || isRemove
                          }
                        >
                          Remove
                        </CButton>
                      ) : (
                        <CButton
                          color="danger"
                          className="text-capitalize text-white"
                          size="sm"
                          disabled={true}
                        >
                          Remove
                        </CButton>
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center text-capitalize">
                      <CButton
                        color="primary"
                        className="text-capitalize"
                        size="sm"
                        onClick={(e) => handleHistoryDetails(e, item?._id)}
                      >
                        Show History
                      </CButton>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      {item.status == "cvit" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "rejected" ? (
                        <CAvatar
                          size="md"
                          src={
                            item.orderAcceptRejectBy?.avatar
                              ? item.orderAcceptRejectBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "assigned" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripId?.tripAssignedBy?.avatar
                              ? item.tripId.tripAssignedBy.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "driver" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripId?.tripAssignedTo?.avatar
                              ? item.tripId.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                      {item.status == "delivered" ? (
                        <CAvatar
                          size="md"
                          src={
                            item?.tripId?.tripAssignedTo?.avatar
                              ? item.tripId.tripAssignedTo.avatar
                              : demoAvatar
                          }
                          status="success"
                        />
                      ) : (
                        ""
                      )}
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.bookingOrderId}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.transferOrderNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-center">
                      <div>{item.sealBag?.serialNo}</div>
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.fromLocation
                        ? `${item.fromLocation.name} (${item.fromLocation.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.toLocation
                        ? `${item.toLocation.name} (${item?.toLocation?.locationCode})`
                        : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.type ? item.type.name : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.unit ? item.unit.name : ""}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.tripId?.tripRoute?.name}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item.priority}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {moment(item.pickupDate).format("DD/MM/YYYY")}{" "}
                      {item.pickupTime}
                    </CTableDataCell>
                    <CTableDataCell className="text-capitalize">
                      {item?.remarks}
                    </CTableDataCell>
                  </CTableRow>
                ))
              )}
            </CTableBody>
          </CTable>
          <br />
          <CustomPagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </CCardBody>
      </CCard>
      <MessageModal
        visible={visibleMessageModal}
        setVisibleMessageModal={setVisibleMessageModal}
        message={selectedMessage}
        title={selectedModalTitle}
        // addToast={addToast}
      />
      <RemoveOrderModal
        selectedOderToRemove={selectedOderToRemove}
        setSelectedOrderToRemove={setSelectedOrderToRemove}
        orderRemovePriority={orderRemovePriority}
        setOrderRemovePriority={setOrderRemovePriority}
        onConfirm={handleRemoveRejectOrder}
      />
    </>
  );
};

export default TripOrdersTable;
